var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "taskRepository" } },
    [
      _c("el-header", { staticClass: "task-header" }, [
        _c(
          "div",
          { staticClass: "header-left" },
          [
            _c("h1", [_vm._v("任务库")]),
            _vm._v(" "),
            _c(
              "el-popover",
              {
                staticClass: "choice",
                attrs: {
                  placement: "bottom-start",
                  width: "288",
                  trigger: "click"
                }
              },
              [
                _c("div", { staticClass: "taskChoice" }, [
                  _c("span", { staticClass: "title" }, [
                    _vm._v("请选择创建的任务类型")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "choice" }, [
                    _c(
                      "div",
                      {
                        on: {
                          click: function($event) {
                            _vm.ptTaskDetail = true
                          }
                        }
                      },
                      [
                        _c("img", {
                          attrs: { src: require("./normalTask.png") }
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v("普通任务")])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        on: {
                          click: function($event) {
                            _vm.xhTaskDetail = true
                          }
                        }
                      },
                      [
                        _c("img", {
                          attrs: { src: require("./circleTask.png") }
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v("循环任务")])
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("el-button", {
                  attrs: {
                    slot: "reference",
                    icon: "el-icon-circle-plus-outline",
                    size: "mini",
                    circle: ""
                  },
                  slot: "reference"
                })
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "header-right" },
          [
            _c(
              "el-input",
              {
                attrs: { placeholder: "搜索任务名称", size: "small" },
                on: { input: _vm.searchList },
                model: {
                  value: _vm.searchName,
                  callback: function($$v) {
                    _vm.searchName = $$v
                  },
                  expression: "searchName"
                }
              },
              [
                _c("i", {
                  staticClass: "el-input__icon el-icon-search",
                  attrs: { slot: "prefix" },
                  slot: "prefix"
                })
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "el-row",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.taskLoad,
              expression: "taskLoad"
            }
          ],
          staticClass: "task-list",
          attrs: { gutter: 8 }
        },
        [
          _vm.total === 0
            ? _c("div", { staticClass: "noData" }, [
                _c("p", { staticClass: "tip" }, [_vm._v("暂无数据")]),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c("span", [_vm._v("请点击")]),
                    _vm._v(" "),
                    _c(
                      "el-popover",
                      {
                        staticClass: "choice",
                        attrs: {
                          placement: "bottom-start",
                          width: "288",
                          trigger: "click"
                        }
                      },
                      [
                        _c("div", { staticClass: "taskChoice" }, [
                          _c("span", { staticClass: "title" }, [
                            _vm._v("请选择创建的任务类型")
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "choice" }, [
                            _c(
                              "div",
                              {
                                on: {
                                  click: function($event) {
                                    _vm.ptTaskDetail = true
                                  }
                                }
                              },
                              [
                                _c("img", {
                                  attrs: { src: require("./normalTask.png") }
                                }),
                                _vm._v(" "),
                                _c("span", [_vm._v("普通任务")])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                on: {
                                  click: function($event) {
                                    _vm.xhTaskDetail = true
                                  }
                                }
                              },
                              [
                                _c("img", {
                                  attrs: { src: require("./circleTask.png") }
                                }),
                                _vm._v(" "),
                                _c("span", [_vm._v("循环任务")])
                              ]
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("el-button", {
                          attrs: {
                            slot: "reference",
                            icon: "el-icon-circle-plus-outline",
                            size: "mini",
                            circle: ""
                          },
                          slot: "reference"
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("span", [_vm._v("添加任务")])
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.taskRepository, function(item, index) {
            return _c("el-col", { key: index, attrs: { span: 4 } }, [
              _c(
                "div",
                {
                  staticClass: "task-item",
                  on: {
                    click: function($event) {
                      return _vm.showEdit(item.tableId, item.tableType)
                    }
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "task-list-name",
                      attrs: { title: item.tableName }
                    },
                    [
                      _c("span", {
                        staticClass: "sign",
                        class: { circleSign: item.tableType === "C" }
                      }),
                      _vm._v(" "),
                      _c("span", [
                        _c("p", [_vm._v(_vm._s(item.tableName))]),
                        _vm._v(" "),
                        _c("p", [_vm._v(_vm._s(item.remark))])
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-popover",
                    { attrs: { placement: "bottom", trigger: "hover" } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "danger text", size: "small" },
                          on: {
                            click: function($event) {
                              return _vm.delData(item.tableId, item.tableType)
                            }
                          }
                        },
                        [_vm._v("删除")]
                      ),
                      _vm._v(" "),
                      _c("i", {
                        staticClass: "iconfont icon_gengduo",
                        attrs: { slot: "reference" },
                        slot: "reference"
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ])
          })
        ],
        2
      ),
      _vm._v(" "),
      _c("el-footer", [
        _c(
          "div",
          { staticClass: "equipPaging" },
          [
            _c("el-pagination", {
              attrs: {
                small: "",
                background: "",
                "pager-count": 5,
                layout: "prev, pager, next",
                "page-size": _vm.pageSize,
                "current-page": _vm.pageNo,
                total: _vm.total
              },
              on: { "current-change": _vm.currentChange }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            width: "960px",
            top: "10vh",
            "close-on-click-modal": false,
            visible: _vm.ptTaskDetail,
            center: ""
          },
          on: {
            "update:visible": function($event) {
              _vm.ptTaskDetail = $event
            },
            closed: _vm.closePtDetail
          }
        },
        [
          _c("div", { attrs: { slot: "title" }, slot: "title" }, [
            _c("p", [
              _c("span", { staticClass: "pt-task-logo" }),
              _vm._v("新增普通任务")
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "dialog-body flex-start-body" }, [
            _c(
              "div",
              { staticClass: "dialog-body-pt-left dialog-body-item" },
              [
                _c("el-header", [_vm._v("任务信息")]),
                _vm._v(" "),
                _c(
                  "el-form",
                  {
                    ref: "ptForm",
                    staticClass: "base-info",
                    attrs: { model: _vm.ptForm, rules: _vm.ptRule }
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "任务名称", prop: "tableName" } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "请输入", size: "small" },
                          model: {
                            value: _vm.ptForm.tableName,
                            callback: function($$v) {
                              _vm.$set(_vm.ptForm, "tableName", $$v)
                            },
                            expression: "ptForm.tableName"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "任务描述" } },
                      [
                        _c("el-input", {
                          attrs: {
                            type: "textarea",
                            maxlength: "30",
                            placeholder: "请输入任务内容描述.."
                          },
                          model: {
                            value: _vm.ptForm.comment,
                            callback: function($$v) {
                              _vm.$set(_vm.ptForm, "comment", $$v)
                            },
                            expression: "ptForm.comment"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "dialog-body-pt-right" }, [
              _c(
                "div",
                { staticClass: "task-sys-list dialog-body-item" },
                [
                  _c("el-header", { staticClass: "body-title" }, [
                    _vm._v(
                      "\n                        系统控制项\n                        "
                    ),
                    _c("div", [
                      _c("i", {
                        staticClass: "el-icon-circle-plus-outline",
                        on: { click: _vm.addPtTaskSys }
                      }),
                      _vm._v(" "),
                      _c("i", {
                        staticClass: "iconfont iconshanchu",
                        on: { click: _vm.deletePtTaskSys }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "task-table" },
                    [
                      _c(
                        "el-table",
                        {
                          ref: "taskSysTable",
                          staticStyle: { width: "100%" },
                          attrs: {
                            data: _vm.ptForm.procTaskSys,
                            "cell-style": _vm.cellStyle
                          },
                          on: { "selection-change": _vm.sysSelectionChange }
                        },
                        [
                          _c("el-table-column", {
                            attrs: { type: "selection", width: "32" }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "序号", width: "1" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _vm._v(
                                      _vm._s(
                                        (scope.row.index = scope.$index + 1)
                                      )
                                    )
                                  ]
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "时间", width: "104" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c("el-time-picker", {
                                      attrs: {
                                        size: "small",
                                        clearable: false
                                      },
                                      model: {
                                        value: scope.row.time,
                                        callback: function($$v) {
                                          _vm.$set(scope.row, "time", $$v)
                                        },
                                        expression: "scope.row.time"
                                      }
                                    })
                                  ]
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "控制项名称" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: {
                                          placeholder: "请选择",
                                          size: "small"
                                        },
                                        model: {
                                          value: scope.row.procCode,
                                          callback: function($$v) {
                                            _vm.$set(scope.row, "procCode", $$v)
                                          },
                                          expression: "scope.row.procCode"
                                        }
                                      },
                                      _vm._l(_vm.sysList, function(item) {
                                        return _c("el-option", {
                                          key: item.procCode,
                                          attrs: {
                                            label: item.procName,
                                            value: item.procCode
                                          }
                                        })
                                      }),
                                      1
                                    )
                                  ]
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "有效时段", width: "104" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c("el-time-picker", {
                                      attrs: {
                                        size: "small",
                                        clearable: false
                                      },
                                      model: {
                                        value: scope.row.timeDur,
                                        callback: function($$v) {
                                          _vm.$set(scope.row, "timeDur", $$v)
                                        },
                                        expression: "scope.row.timeDur"
                                      }
                                    })
                                  ]
                                }
                              }
                            ])
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "task-eqp-list dialog-body-item" },
                [
                  _c("el-header", { staticClass: "body-title" }, [
                    _vm._v(
                      "\n                        设备控制项\n                        "
                    ),
                    _c("div", [
                      _c("i", {
                        staticClass: "el-icon-circle-plus-outline",
                        on: { click: _vm.addPtTaskEqp }
                      }),
                      _vm._v(" "),
                      _c("i", {
                        staticClass: "iconfont iconshanchu",
                        on: { click: _vm.deletePtTaskEqp }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "task-table" },
                    [
                      _c(
                        "el-table",
                        {
                          ref: "taskEqpTable",
                          staticStyle: { width: "100%" },
                          attrs: {
                            data: _vm.ptForm.procTaskEqp,
                            "cell-style": _vm.cellStyle
                          },
                          on: { "selection-change": _vm.eqpSelectionChange }
                        },
                        [
                          _c("el-table-column", {
                            attrs: { type: "selection", width: "32" }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "序号", width: "1" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _vm._v(
                                      _vm._s(
                                        (scope.row.index = scope.$index + 1)
                                      )
                                    )
                                  ]
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "时间", width: "104" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c("el-time-picker", {
                                      attrs: {
                                        size: "small",
                                        clearable: false
                                      },
                                      model: {
                                        value: scope.row.time,
                                        callback: function($$v) {
                                          _vm.$set(scope.row, "time", $$v)
                                        },
                                        expression: "scope.row.time"
                                      }
                                    })
                                  ]
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "控制项名称" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c("el-cascader", {
                                      ref: scope.$index + 1,
                                      attrs: {
                                        options: _vm.eqpList,
                                        size: "small",
                                        props: _vm.casProp
                                      },
                                      on: {
                                        change: function($event) {
                                          return _vm.changePtCascader(
                                            scope.$index + 1
                                          )
                                        }
                                      },
                                      model: {
                                        value: scope.row.equipSetValue,
                                        callback: function($$v) {
                                          _vm.$set(
                                            scope.row,
                                            "equipSetValue",
                                            $$v
                                          )
                                        },
                                        expression: "scope.row.equipSetValue"
                                      }
                                    })
                                  ]
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "设置值", width: "104" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c("el-input-number", {
                                      attrs: {
                                        size: "small",
                                        disabled:
                                          _vm.cascaderPtArr[scope.$index]
                                      },
                                      model: {
                                        value: scope.row.value,
                                        callback: function($$v) {
                                          _vm.$set(scope.row, "value", $$v)
                                        },
                                        expression: "scope.row.value"
                                      }
                                    })
                                  ]
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "有效时段", width: "104" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c("el-time-picker", {
                                      attrs: {
                                        size: "small",
                                        clearable: false
                                      },
                                      model: {
                                        value: scope.row.timeDur,
                                        callback: function($$v) {
                                          _vm.$set(scope.row, "timeDur", $$v)
                                        },
                                        expression: "scope.row.timeDur"
                                      }
                                    })
                                  ]
                                }
                              }
                            ])
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function($event) {
                      _vm.ptTaskDetail = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.savePtTask }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            width: "1200px",
            top: "10vh",
            visible: _vm.xhTaskDetail,
            "close-on-click-modal": false,
            center: ""
          },
          on: {
            "update:visible": function($event) {
              _vm.xhTaskDetail = $event
            },
            closed: _vm.closeXhDetail
          }
        },
        [
          _c("div", { attrs: { slot: "title" }, slot: "title" }, [
            _c("p", [
              _c("span", { staticClass: "xh-task-logo" }),
              _vm._v("新增循环任务")
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "dialog-body" }, [
            _c("div", { staticClass: "dialog-body-xh-left" }, [
              _c(
                "div",
                { staticClass: "dialog-body-item" },
                [
                  _c("el-header", [_vm._v("任务信息")]),
                  _vm._v(" "),
                  _c(
                    "el-form",
                    {
                      ref: "xhForm",
                      staticClass: "base-info",
                      attrs: { model: _vm.xhForm, rules: _vm.xhRule }
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "任务名称", prop: "tableName" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入", size: "small" },
                            model: {
                              value: _vm.xhForm.tableName,
                              callback: function($$v) {
                                _vm.$set(_vm.xhForm, "tableName", $$v)
                              },
                              expression: "xhForm.tableName"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "任务描述" } },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              maxlength: "30",
                              placeholder: "请输入任务内容描述.."
                            },
                            model: {
                              value: _vm.xhForm.comment,
                              callback: function($$v) {
                                _vm.$set(_vm.xhForm, "comment", $$v)
                              },
                              expression: "xhForm.comment"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "执行时间",
                            prop: "cycleTask.intervalTime"
                          }
                        },
                        [
                          _c("el-time-picker", {
                            attrs: {
                              "is-range": "",
                              "range-separator": "至",
                              "start-placeholder": "开始时间",
                              "end-placeholder": "结束时间",
                              placeholder: "选择时间范围",
                              size: "small",
                              clearable: false
                            },
                            model: {
                              value: _vm.xhForm.cycleTask.intervalTime,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.xhForm.cycleTask,
                                  "intervalTime",
                                  $$v
                                )
                              },
                              expression: "xhForm.cycleTask.intervalTime"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "dialog-body-item" },
                [
                  _c(
                    "el-collapse",
                    {
                      model: {
                        value: _vm.activeNames,
                        callback: function($$v) {
                          _vm.activeNames = $$v
                        },
                        expression: "activeNames"
                      }
                    },
                    [
                      _c(
                        "el-collapse-item",
                        { attrs: { title: "附加设置", name: "1" } },
                        [
                          _c(
                            "el-form",
                            {
                              staticClass: "base-info",
                              attrs: {
                                model: _vm.xhForm,
                                rules: _vm.xhForm,
                                "label-position": "top"
                              }
                            },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "执行方式" } },
                                [
                                  _c(
                                    "el-radio-group",
                                    {
                                      attrs: { size: "small" },
                                      model: {
                                        value: _vm.xhForm.cycleTask.implement,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.xhForm.cycleTask,
                                            "implement",
                                            $$v
                                          )
                                        },
                                        expression: "xhForm.cycleTask.implement"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-radio",
                                        { attrs: { label: "1", border: "" } },
                                        [_vm._v("立即开始执行")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-radio",
                                        { attrs: { label: "2", border: "" } },
                                        [_vm._v("整点开始执行")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-radio",
                                        { attrs: { label: "3", border: "" } },
                                        [
                                          _vm._v(
                                            "指定开始时间\n                                            "
                                          ),
                                          _c("el-time-picker", {
                                            attrs: {
                                              size: "small",
                                              clearable: false
                                            },
                                            model: {
                                              value:
                                                _vm.xhForm.cycleTask
                                                  .zhidingTime,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.xhForm.cycleTask,
                                                  "zhidingTime",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "xhForm.cycleTask.zhidingTime"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                { attrs: { label: "限制最大循环次数" } },
                                [
                                  _c(
                                    "el-checkbox",
                                    {
                                      attrs: { border: "", size: "small" },
                                      model: {
                                        value: _vm.xhForm.cycleTask.isMaxCycle,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.xhForm.cycleTask,
                                            "isMaxCycle",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "xhForm.cycleTask.isMaxCycle"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "限制最大执行次数\n                                        "
                                      ),
                                      _c("el-input-number", {
                                        attrs: {
                                          disabled: !_vm.xhForm.cycleTask
                                            .isMaxCycle,
                                          size: "small"
                                        },
                                        model: {
                                          value:
                                            _vm.xhForm.cycleTask.maxCycleNum,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.xhForm.cycleTask,
                                              "maxCycleNum",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "xhForm.cycleTask.maxCycleNum"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("el-checkbox", {
                                    attrs: {
                                      label: "执行完整循环",
                                      border: "",
                                      size: "small"
                                    },
                                    model: {
                                      value:
                                        _vm.xhForm.cycleTask.cycleMustFinish,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.xhForm.cycleTask,
                                          "cycleMustFinish",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "xhForm.cycleTask.cycleMustFinish"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "dialog-body-xh-center dialog-body-item" },
              [
                _c("el-header", [_vm._v("任务控制项")]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "base-info" },
                  [
                    _c(
                      "draggable",
                      _vm._b(
                        {
                          staticClass: "ctr-list",
                          attrs: { tag: "div" },
                          model: {
                            value: _vm.xhForm.cycleTaskContent,
                            callback: function($$v) {
                              _vm.$set(_vm.xhForm, "cycleTaskContent", $$v)
                            },
                            expression: "xhForm.cycleTaskContent"
                          }
                        },
                        "draggable",
                        _vm.dragOptions,
                        false
                      ),
                      [
                        _c(
                          "transition-group",
                          { attrs: { type: "transition" } },
                          _vm._l(_vm.xhForm.cycleTaskContent, function(
                            item,
                            index
                          ) {
                            return _c(
                              "div",
                              {
                                key: index,
                                staticClass: "ctr-item dialog-body-item"
                              },
                              [
                                _c("i", {
                                  staticClass: "iconfont icontuozhuai"
                                }),
                                _vm._v(" "),
                                item.type === "S"
                                  ? _c("p", [
                                      _vm._v("系统控制：" + _vm._s(item.cmdNm))
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                item.type === "E"
                                  ? _c("p", [
                                      _vm._v(
                                        "设备控制：" + _vm._s(item.equipSetNm)
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                item.type === "T"
                                  ? _c("p", [
                                      _vm._v(
                                        "时间间隔：" +
                                          _vm._s(_vm.getTime(item.sleepTime))
                                      )
                                    ])
                                  : _vm._e()
                              ]
                            )
                          }),
                          0
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "draggable",
                      _vm._b(
                        {
                          staticClass: "del-ctr-list",
                          attrs: { options: { draggable: ".item" }, tag: "div" }
                        },
                        "draggable",
                        _vm.dragOptions,
                        false
                      ),
                      [
                        _c("div", [
                          _c("i", { staticClass: "iconfont iconshanchu" }),
                          _vm._v(
                            "\n                            拖动到此处删除\n                        "
                          )
                        ])
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "dialog-body-xh-right" }, [
              _c(
                "div",
                { staticClass: "dialog-body-item" },
                [
                  _c(
                    "el-header",
                    { staticClass: "body-title" },
                    [
                      _vm._v(
                        "\n                        系统控制项\n                        "
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            size: "small",
                            icon: "el-icon-circle-plus-outline"
                          },
                          on: { click: _vm.addSysItem }
                        },
                        [_vm._v("添加")]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "base-info" },
                    [
                      _c(
                        "el-form",
                        {
                          attrs: {
                            model: _vm.xhSysForm,
                            "label-position": "top"
                          }
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "选择控制项", prop: "tableName" }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    placeholder: "请选择",
                                    size: "small"
                                  },
                                  model: {
                                    value: _vm.xhSysForm.control,
                                    callback: function($$v) {
                                      _vm.$set(_vm.xhSysForm, "control", $$v)
                                    },
                                    expression: "xhSysForm.control"
                                  }
                                },
                                _vm._l(_vm.sysList, function(item) {
                                  return _c("el-option", {
                                    key: item.procCode,
                                    attrs: {
                                      label: item.procName,
                                      value: item.procCode
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "dialog-body-item" },
                [
                  _c(
                    "el-header",
                    { staticClass: "body-title" },
                    [
                      _vm._v(
                        "\n                        设备控制项\n                        "
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            size: "small",
                            icon: "el-icon-circle-plus-outline"
                          },
                          on: { click: _vm.addEqpItem }
                        },
                        [_vm._v("添加")]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "base-info" },
                    [
                      _c(
                        "el-form",
                        {
                          attrs: {
                            model: _vm.xhEqpForm,
                            "label-position": "top"
                          }
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "选择控制项", prop: "tableName" }
                            },
                            [
                              _c("el-cascader", {
                                ref: "xhCascader",
                                attrs: {
                                  options: _vm.eqpList,
                                  size: "small",
                                  props: _vm.casProp
                                },
                                on: { change: _vm.changeXhCascader },
                                model: {
                                  value: _vm.xhEqpForm.control,
                                  callback: function($$v) {
                                    _vm.$set(_vm.xhEqpForm, "control", $$v)
                                  },
                                  expression: "xhEqpForm.control"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "设置值", prop: "tableName" } },
                            [
                              _c("el-input-number", {
                                attrs: {
                                  size: "small",
                                  disabled: _vm.cascaderXh
                                },
                                model: {
                                  value: _vm.xhEqpForm.value,
                                  callback: function($$v) {
                                    _vm.$set(_vm.xhEqpForm, "value", $$v)
                                  },
                                  expression: "xhEqpForm.value"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "dialog-body-item" },
                [
                  _c(
                    "el-header",
                    { staticClass: "body-title" },
                    [
                      _vm._v(
                        "\n                        时间间隔\n                        "
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            size: "small",
                            icon: "el-icon-circle-plus-outline"
                          },
                          on: { click: _vm.addTimeItem }
                        },
                        [_vm._v("添加")]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "base-info" },
                    [
                      _c(
                        "el-form",
                        { attrs: { model: _vm.xhTimeForm } },
                        [
                          _c(
                            "el-row",
                            { attrs: { gutter: 8 } },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    [
                                      _c("el-input-number", {
                                        attrs: {
                                          size: "small",
                                          placeholder: "天"
                                        },
                                        model: {
                                          value: _vm.xhTimeForm.day,
                                          callback: function($$v) {
                                            _vm.$set(_vm.xhTimeForm, "day", $$v)
                                          },
                                          expression: "xhTimeForm.day"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    [
                                      _c("el-input-number", {
                                        attrs: {
                                          size: "small",
                                          placeholder: "时"
                                        },
                                        model: {
                                          value: _vm.xhTimeForm.hour,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.xhTimeForm,
                                              "hour",
                                              $$v
                                            )
                                          },
                                          expression: "xhTimeForm.hour"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    [
                                      _c("el-input-number", {
                                        attrs: {
                                          size: "small",
                                          placeholder: "分"
                                        },
                                        model: {
                                          value: _vm.xhTimeForm.min,
                                          callback: function($$v) {
                                            _vm.$set(_vm.xhTimeForm, "min", $$v)
                                          },
                                          expression: "xhTimeForm.min"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    [
                                      _c("el-input-number", {
                                        attrs: {
                                          size: "small",
                                          placeholder: "秒"
                                        },
                                        model: {
                                          value: _vm.xhTimeForm.second,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.xhTimeForm,
                                              "second",
                                              $$v
                                            )
                                          },
                                          expression: "xhTimeForm.second"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function($event) {
                      _vm.xhTaskDetail = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.saveXhTask }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-9ace4170", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-9ace4170","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/taskRepository.vue
// module id = 15
// module chunks = 0